import { render, staticRenderFns } from "./transferredModal.vue?vue&type=template&id=1614e7a5&scoped=true&"
import script from "./transferredModal.vue?vue&type=script&lang=js&"
export * from "./transferredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1614e7a5",
  null
  
)

export default component.exports